<template>
  <div class="office-info">
    <ul>
      <office-item
        v-for="item in $t('officeInfo')"
        :key="$t('officeInfo').indexOf(item)"
        :item="item"
      ></office-item>
    </ul>
  </div>
</template>

<script>
import OfficeItem from '@/components/ItemOffice.vue';

export default {
  name: 'OfficeContainer',
  components: {
    OfficeItem,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
div.office-info {
  width: 30%;
  position: absolute;
  top: 50%;
  left: 80%;
  transform: translate(-50%, -50%);
  background-color: transparent;

  ul {
    margin: 0;
    padding: 0;
    background-color: transparent;
  }
}

@media screen and (max-width: 900px) {
  .office-info {
    width: 40% !important;
    left: 70% !important;
  }
}

@media screen and (max-width: 600px) {
  .office-info {
    margin: 20px;
    width: calc(100% - 40px) !important;
    position: static !important;
    transform: none !important;

     ul {
       height: auto;
       background-color: #fff !important;
     }
  }
}
</style>
